import { animated, useSpring } from '@react-spring/web';
import { hooks } from '@wove/react';
import { FC, useState } from 'react';
import { NativeProps } from '../utils';

export type NumberAnimationProps = {
  startNumber: number;
  endNumber: number;
  delay?: number;
  precision?: number;
  duration?: number;
} & NativeProps;

/**
 * 数字动画组件
 * ```
 * 1. delay: 延迟滚动毫秒时间；默认值：400
 * 2. precision: 数字显示精度；默认值：0
 * 3. duration: 动画持续毫秒时间；默认值：1500
 * ```
 */
export const NumberAnimation: FC<NumberAnimationProps> = (props) => {
  const [start, setStart] = useState(false);

  hooks.useTimeout(() => {
    setStart(true);
  }, props.delay as number);

  const spring = useSpring({
    number: start ? props.endNumber : props.startNumber,
    config: {
      duration: props.duration,
    },
  });

  return (
    <animated.span className={props.className} style={props.style}>
      {spring.number.to((x) => x.toFixed(props.precision))}
    </animated.span>
  );
};

NumberAnimation.defaultProps = {
  precision: 0,
  delay: 400,
  duration: 1500,
};
